import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(public restService: RestService) { }

  authenticate(username, password) {
    return this.restService.post('staff-authentication',{
      username,
      password,
      strategy: 'local'
    });
  }
}
